import { createContext } from 'react';

import useAuthState from './hooks/use-auth-state';

export type AuthContextProps = ReturnType<typeof useAuthState>;

export const AuthContext = createContext<AuthContextProps | undefined>(undefined);
AuthContext.displayName = 'AuthContext';
